import { type GetProductSourcesQueryVariables, useGetProductSourcesQuery } from '.'

export const useGetProductSources = (variables: GetProductSourcesQueryVariables) => {
  const {
    data,
    error: apiError,
    loading: apiLoading,
    refetch: apiRefetch,
  } = useGetProductSourcesQuery({
    variables,
  })

  const sources = data?.productSourceServiceGetProductSources?.sources

  return {
    sources: sources,
    apiError,
    apiLoading,
    apiRefetch,
  }
}
